import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { db } from '../firebase';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';

interface SystemConfig {
  betaEnabled: boolean;
  betaRequireAllowlist: boolean;
  betaAllowlist: string[];
  betaMessage: string;
  appVersion: string;
}

interface SystemState {
  config: SystemConfig;
  configLoaded: boolean;
  syncWithFirestore: () => () => void;
}

export const useSystemStore = create<SystemState>()(
  persist(
    (set, get) => ({
      config: {
        betaEnabled: true,
        betaRequireAllowlist: false,
        betaAllowlist: [],
        betaMessage: "Esta aplicación está en fase beta y puede contener errores o cambios en algunas funciones. Gracias por probarla y ayudarnos a mejorar.",
        appVersion: "1.0.0"
      },
      configLoaded: false,
      syncWithFirestore: () => {
        // Safety timeout to prevent blocking the app if Firestore is unresponsive
        const timeoutId = setTimeout(() => {
          if (!get().configLoaded) {
            set({ configLoaded: true });
          }
        }, 8000);

        const unsub = onSnapshot(doc(db, 'system', 'config'), (snapshot) => {
          clearTimeout(timeoutId);
          
          if (snapshot.exists()) {
            const data = snapshot.data() as Partial<SystemConfig>;
            set(state => ({
              config: {
                ...state.config,
                ...data
              },
              configLoaded: true
            }));
          } else {
            set({ configLoaded: true });
          }
        }, (error) => {
          console.error("[System] Firestore sync failed:", error.message);
          clearTimeout(timeoutId);
          set({ configLoaded: true });
        });
        return unsub;
      },
    }),
    {
      name: 'system-storage-v5',
      version: 5,
    }
  )
);
